import { render, staticRenderFns } from "./SignupB.vue?vue&type=template&id=3496dda8&scoped=true&"
import script from "./SignupB.vue?vue&type=script&lang=js&"
export * from "./SignupB.vue?vue&type=script&lang=js&"
import style0 from "./SignupB.vue?vue&type=style&index=0&id=3496dda8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3496dda8",
  null
  
)

component.options.__file = "SignupB.vue"
export default component.exports